module.exports = __webpack_public_path__ + "static/img/codeEn.0509ff49.png";